import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
} from '@material-ui/core';
import ExpansionPanel from './ExpansionPanel';

class PasswordForm extends PureComponent {
  constructor() {
    super();

    this.state = {
      password: '',
      password_confirmation: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { onSubmit, user, userId } = this.props;

    onSubmit({ [user]: { id: userId, ...this.state } });
  }

  render() {
    const {
      password,
      password_confirmation,
    } = this.state;

    const { errors } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <ExpansionPanel submitable header="Cambiar Contraseña">
          <Grid container alignItems="center" spacing={32}>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                value={password}
                label="Contraseña"
                type="password"
                name="password"
                error={!!errors.password}
                helperText={errors.password ? errors.password[0] : ''}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                value={password_confirmation}
                label="Confirmar Contraseña"
                name="password_confirmation"
                type="password"
                error={!!errors.password_confirmation}
                helperText={errors.password_confirmation ? errors.password_confirmation[0] : ''}
                onChange={this.handleChange}
              />
            </Grid>
          </Grid>
        </ExpansionPanel>
      </form>
    );
  }
}

export default PasswordForm;

PasswordForm.propTypes = {
  user: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  errors: PropTypes.object,
  userId: PropTypes.number,
};

PasswordForm.defaultProps = {
  onSubmit: () => {},
  errors: {},
  userId: 0,
};



// WEBPACK FOOTER //
// ./src/components/PasswordForm.js